const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const initialUser = {
  phone: '',
  email: '',
  password: '',
  passwordConfirm: '',
};

export default {
  props: ['type'],
  data() {
    return {
      user: { ...initialUser },
      code: '',
      sentCode: false,
      token: null,
      hidePw: true,
      phoneRules: [v => (!v.length || v.length >= 17) || 'Номер телефона заполнен не полностью'],
      emailRules: [v => pattern.test(v) || 'Поле E-mail заполнено с ошибками'],
      codeRules: [v => !!v || 'Укажите проверочный код'],
      passwordRules: [v => !!v || 'Укажите пароль'],
      email_redirect: false,
      region: 'RU',
    };
  },
  computed: {
    isManager() { return this.$props.type === 'manager'; },
    isDealer() { return this.$props.type === 'dealer'; },
    loading() { return this.$store.state.loading; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    registerType() {
      let type;
      if (this.isManager || this.email_redirect) {
        type = 'email_profile';
      }
      if (this.isDealer && !this.email_redirect) {
        type = 'sms_profile';
      }
      return type;
    },
  },
  methods: {
    /** Фокус на нужном поле формы */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей форм при успехе */
    Reset() {
      this.user = { ...initialUser };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.region = 'RU';
      this.Focus(this.isManager ? 'remindEmail' : 'remindPhone');
    },
    /** Редирект на форму входа */
    Back() {
      this.$router.back();
      this.$router.push(`/login/${this.$props.type}`);
    },
    /** Отправка проверочного СМС кода */
    SendSMSCode() {
      const app = this;
      const url = 'profiles/api/v3/token/get-sms';

      app.$store.getters.axl.post(url, { type: app.registerType, phone: app.user.phone })
        .then(({ data }) => {
          app.email_redirect = data.email_redirect;
          app.region = data.region;
          app.regionalPhone = data.email_redirect ? app.user.phone : '';
          if (!data.email_redirect) {
            app.sentCode = true;
            app.Focus('remindCode');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('remindPhone');
        });
    },
    /** Отправка проверочного email кода */
    SendEmailCode() {
      const app = this;
      const url = 'profiles/api/v3/token/get-email';

      app.$store.getters.axl.post(url, { type: app.registerType, email: app.user.email })
        .then(() => {
          app.sentCode = true;
          app.Focus('remindCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('remindEmail');
        });
    },
    /** Проверка кода полученного в СМС или email */
    CheckCode() {
      const app = this;
      let url = 'profiles/api/v3/token/check-sms';
      let payload = { type: app.registerType, code: app.code, phone: app.user.phone };

      if (app.isManager || app.email_redirect) {
        url = 'profiles/api/v3/token/check-email';
        payload = { type: app.registerType, code: app.code, email: app.user.email };
      }
      app.$store.getters.axl.post(url, payload)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('remindCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка измененного пароля на сервер */
    Remind() {
      const app = this;
      const url = (app.isManager || app.email_redirect) ? 'api/remind/email' : 'api/remind';
      const formData = app.user;
      formData.token = app.token;

      app.$store.getters.axl.post(url, formData)
        .then((response) => {
          app.Reset();
          app.$store.dispatch('ShowInfo', response.data.msg);
          app.$router.push(`/login/${app.$props.type}`);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  created() {
    this.Focus(this.isManager ? 'remindEmail' : 'remindPhone');
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
  },
};
